<script>
  import router from '../../lib/router';
  import { onMount } from 'svelte';
  import APIClient from '../../state-charts/api-client';
  import { MDCDialog } from '@material/dialog';
  import { download_file } from '../../lib/utils.js';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import session from '../../lib/session.js';
  import settings from '../../config';

  import Profile from '../../profiles/public-profile.js';
  import TextField from '../../lib/components/TextField.svelte';
  import AuthenticatedLayout from '../../app-shell/authorized-app/Layout.svelte';
  import UserBanner from './components/Banner.svelte';
  import SelectUser from './components/SelectUser.svelte';
  import TableUser from './components/TableUser.svelte';
  import TableOrder from './components/TableOrder.svelte';
  import Receipt from './components/Receipt.svelte';
  import Approve from './components/Approve.svelte';
  import Certificate from './components/Certificate.svelte';
  import OrderComment from './components/OrderComment.svelte';
  import Dialog from '../../lib/components/Dialog.svelte';
  import Complete from './components/Complete.svelte';
  import Share from './components/Share.svelte';
  import AddUnit from './components/AddUnit.svelte';
  import NetsPaymentWindow from '../../lib/workpilots-ui/NetsPaymentWindow.svelte';
  import DurationWarning from './components/DurationWarning.svelte';
  import { show_message } from '../../lib/flash';
  import Rating from '../../profiles/components/Rating.svelte';
  import UpdateFeedback from './components/UpdateFeedback.svelte';

  // component options  ------------------------------------------------------ //

  // export let route_name;
  export let query;

  // internal variables ------------------------------------------------------ //

  let on_mount = false;
  let call_select_worker = false;
  let receipt_dialog;
  let order_uuid;
  let order;
  let applications;
  let has_inited = false;
  let buttons = [];
  let complete_dialog;
  let partner_id = null;
  let no_comment_warning = true;

  let short_comment;
  let short_comment_approve;
  let approve_dialog;
  let certificate_dialog;
  let is_approved;
  let share_dialog;
  let unit_dialog;
  let dialog_worker_email;
  let update_dialog;

  let nets_host;
  let show_nets = false;
  let transaction_id;
  let nets_status;
  let select_applicant = false;
  let make_a_copy;
  let worker_id;

  let is_open = false;
  let wait_api = false;

  let add_unit_tooltip = t9n(TS.TOOLTIPS_ADDITIONAL_UNITS);

  let tooltip_dictionary = {
    'product_based_hours': t9n(TS.TOOLTIPS_ADDITIONAL_HOURS),
    'product_based_days': t9n(TS.TOOLTIPS_ADDITIONAL_DAYS),
    'product_based_months': t9n(TS.TOOLTIPS_ADDITIONAL_MONTH),
    'product_based_units': t9n(TS.TOOLTIPS_ADDITIONAL_UNITS),
    'product_based_price': t9n(TS.TOOLTIPS_ADDITIONAL_PRICE)
  }

  let no_certificate = false;

  // translations  ------------------------------------------------------ //

  let apply_to_task;
  let share;
  let order_status_label;

  let order_status;
  let role = 'orderer';
  let button_back;
  let button_back_to_chat;
  let comment_info;
  let trn_cancel_order;
  let trn_cancel_content;
  let trn_yes;
  let trn_cancel;
  let trn_close;
  let trn_apply_content;
  let trn_apply_content_without_comment;
  let trn_order_cancel_appl;
  let trn_your_comment;
  let hidden_users = false;
  let label_show_workers;
  let label_hide_workers;
  let pay_dialog;
  let is_same_timezone;

  // utility functions ------------------------------------------------------ //

  const open_approve_dialog = is_appr => {
    is_approved = is_appr;

    let target = document.querySelector('.approve-dialog');
    target.innerHTML = '';
    approve_dialog = new Approve({
      target: target,
      props: {
        order: order,
        order_uuid: order_uuid,
        has_inited: has_inited,
        is_approved: is_approved,
      },
    });
    approve_dialog.open();
  };

  const update_worker_feedback = () => {
    let target = document.querySelector('.update-dialog');
    target.innerHTML = '';
    update_dialog = new UpdateFeedback({
      target: target,
      props: {
        order: order,
        order_uuid: order_uuid,
        has_inited: has_inited,
      },
    });
    update_dialog.open();
  }

  const toggle_open = () => {
    is_open = !is_open;
  };

  const open_complete_dialog = () => {
    let target = document.querySelector('.complete-dialog');
    target.innerHTML = '';
    complete_dialog = new Complete({
      target: target,
      props: { order: order, order_uuid: order_uuid, has_inited: has_inited },
    });
    complete_dialog.open();
  };

  const cancel_order = async () => {
    wait_api = true;
    await APIClient.cancel_order({ order_uuid: order_uuid });
    wait_api = false;
    router.navigate('/orders?cancelled=true');
  };

  const get_payment_details = async () => {
    let response = await APIClient.get_order_payment_details(order_uuid);
    download_file(response.url, 'certification of paid fees.pdf');
  };

  const create_delete_dialog = () => {
    let target = document.querySelector('.delete-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'delete-dialog',
        title: trn_cancel_order,
        content: trn_cancel_content,
        buttons: [
          {
            label: trn_close,
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: trn_yes,
            action: async () => {
              await cancel_order();
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  const apply_order = async () => {
    wait_api = true;
    await APIClient.apply_for_order({
      comment: comment_info,
      order_uuid: order_uuid,
    });
    wait_api = false;

    router.navigate('/orders?applied=true');
  };

  const create_apply_dialog = (no_comment_warning) => {
    let content;
    if (no_comment_warning) {
      content = trn_apply_content_without_comment
    } else {
      content = trn_apply_content
    }
    let target = document.querySelector('.apply-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'apply-dialog',
        title: apply_to_task,
        content: content,
        buttons: [
          {
            label: trn_cancel,
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            wait_api: wait_api,
            label: trn_yes,
            action: async () => {
              await apply_order();
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  let toggle_apply_dialog = () => {
    if (!!comment_info === false && no_comment_warning === true) {
      let dialog = create_apply_dialog(true);
      dialog.open();
    } else {
      let dialog = create_apply_dialog(false);
      dialog.open();
    }
  };

  let toggle_delete_dialog = () => {
    let dialog = create_delete_dialog();
    dialog.open();
  };

  let cancel_application = async () => {
    wait_api = true;
    await APIClient.cancel_application({ order_uuid: order_uuid });
    wait_api = false;
    router.navigate('/orders');
  };

  const create_cancel_app_dialog = () => {
    let target = document.querySelector('.cancelapp-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'cancelapp-dialog',
        title: trn_order_cancel_appl,
        content: trn_cancel_content,
        buttons: [
          {
            label: trn_cancel,
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: trn_yes,
            action: async () => {
              await cancel_application();
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  let toggle_cancel_app_dialog = () => {
    let dialog = create_cancel_app_dialog();
    dialog.open();
  };

  const is_object_empty = obj => {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  };

  const is_any_feedback = () => {
    if (
      !is_object_empty(order.feedback.from_orderer) ||
      !is_object_empty(order.feedback.from_worker)
    ) {
      return true;
    }
    return false;
  };

  const back = () => {
    let category = query.group;
    let page = query.page;
    let filters = query.filters;

    if (!!partner_id) {
      router.navigate(`chats/${order_uuid}/partner/${partner_id}`);
    } else if (!!category && !!page) {
      let url = `orders?group=${category}&page=${page}`;
      if(!!filters){
        url += '&filters=true';
        let values = {
          start_date: query.start_date,
          initial_order_time: query.initial_order_time,
          product_name: query.product_name,
          team_code: query.team_code,
          city_name: query.city_name,
          worker_email: query.worker_email,
          order_by: query.order_by,
          order_ascending: query.order_ascending,
        };

        for (let [key, value] of Object.entries(values)) {
          if(!!value){
            url += `&${key}=${value}`
          }
        }
      }

      router.navigate(url);
    } else {
      router.navigate('/orders');
    }
  };

  const open_receipt_dialog = () => {
    let target = document.querySelector('.receipt-dialog');
    target.innerHTML = '';
    receipt_dialog = new Receipt({
      target: target,
      props: { order: order },
    });
    receipt_dialog.open();
  };

  const open_certificate_dialog = () => {
    let target = document.querySelector('.certificate-dialog');
    target.innerHTML = '';
    certificate_dialog = new Certificate({
      target: target,
      props: { order: order },
    });
    certificate_dialog.open();
  };

  const open_share_dialog = () => {
    let target = document.querySelector('.share-dialog');
    target.innerHTML = '';
    share_dialog = new Share({
      target: target,
      props: {
        order: order,
        order_uuid: order_uuid,
        has_inited: has_inited,
      },
    });
    share_dialog.open();
  };

  const add_user_banner = (target, profile, order) => {
    new UserBanner({
      target: target,
      props: {
        profile: profile,
        order: order,
        is_historical_order: is_history_order(order),
      },
    });
  };

  const is_history_order = order => {
    const history_states = [
      'order_status_completed',
      'order_status_not_approved',
      'order_status_cancelled_by_orderer',
      'order_status_cancelled_by_worker',
      'order_status_cancelled_by_admin',
    ];

    return history_states.includes(order.status);
  };

  const load_order = async () => {
    let result = await APIClient.get_order({ order_uuid: order_uuid });
    if (result) {
      order = result;
      order_status = t9n(order.status);
      if (!!order.details.worker_email) {
        await check_worker_email();
      }
    }
  };

  const init_nets_form = async () => {
    let data = {
      order_uuid: order_uuid,
      app: true,
    };
    const transaction_data = await APIClient.init_reserve_card(data);
    if (!!transaction_data) {
      show_nets = true;
      transaction_id = transaction_data.reference;
    }
  };

  const check_different_timezone = () => {
    let current_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return current_timezone === $session.merchant.timezone;
  }

  const init_order_details = async () => {
    document
      .querySelector('.mdc-top-app-bar--fixed-adjust')
      .scrollIntoView({ behavior: 'smooth' });

    order_uuid = query.id;
    nets_host = settings.nets_host;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('chat')) partner_id = urlParams.get('chat');

    // await init_nets_form();
    const target = document.querySelector('#header_section');
    const feedback_target = document.querySelector('#feedback_section');
    let profile;

    await load_order();

    if (!!query.user_id) {
      profile = await Profile.load_applicant_profile(
        query.order_uuid,
        query.user_id
      );
    } else {

      profile = await Profile.load_profile();

    }

    add_user_banner(target, profile, order);


    select_applicant = query.select_applicant === 'true';
    if (select_applicant) {
      make_a_copy = query.make_a_copy === 'true';
      worker_id = Number(query.worker_id);
    }

    no_certificate = $session.merchant.provides_certificate;
    is_same_timezone = check_different_timezone();

    init_buttons();
    translate_texts();
    add_unit_tooltip = tooltip_dictionary[order.product.based_on];
    has_inited = true;
  };

  // $: if(window.performance){
  //   if(performance.navigation.type == 2)
  //   {
  //     debugger;
  //     //Do your code here
  //   }
  // }

  const get_orderer_name = () => {
    return `${order.orderer.basic_profile.first_name} ${order.orderer.basic_profile.last_name}`;
  };

  const get_worker_name = () => {
    return `${order.worker.basic_profile.first_name} ${order.worker.basic_profile.last_name}`;
  };

  const copy_order_process = () => {
    if (!!order.details.worker_email) {
      toggle_copy_worker_dialog();
    } else {
      router.navigate('/order-new?state=copy&id=' + order_uuid);
    }
  }

  const copy_order = () => {
    // if (settings.env === 'production'){
    //   if(is_same_timezone){
    //     copy_order_process();
    //   } else{
    //     show_message(t9n(TS.DIFFERENT_TIMEZONE_ERROR), 'error');
    //   }
    // } else{
      copy_order_process();
    // }
  };

  const edit_order = () => {
    // if (settings.env === 'production'){
    //   if(is_same_timezone){
    //     router.navigate('/order-new?state=edit&id=' + order_uuid);
    //   } else{
    //     show_message(t9n(TS.DIFFERENT_TIMEZONE_ERROR), 'error');
    //   }
    // } else{
       router.navigate('/order-new?state=edit&id=' + order_uuid);
    // }
  }

  const check_worker_email = async () => {
    try {
      let result = await APIClient.verify_email_worker({
        email: order.details.worker_email,
        merchant_uuid: $session.merchant.merchant_uuid,
      });

      dialog_worker_email = result.first_name + ' ' + result.last_name;
    } catch (e) {
      if (e === 'Not found') {
        // is_email_valid = false;
      }
    }
  };

  const create_copy_worker_dialog = () => {
    let target = document.querySelector('.copy-worker-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'copy-worker-dialog',
        title: t9n(TS.ORDER_COPY),
        content: t9n(TS.ORDER_COPY_WORKER, dialog_worker_email),
        buttons: [
          {
            label: t9n(TS.TXT_NO),
            action: () => {
              router.navigate(
                '/order-new?state=copy&id=' + order_uuid + '&copyworker=false'
              );
              dialog.close();
            },
            classes: [],
          },
          {
            label: trn_yes,
            action: () => {
              router.navigate(
                '/order-new?state=copy&id=' + order_uuid + '&copyworker=true'
              );
              dialog.close();
            },
            classes: [],
          },
          {
            label: trn_cancel,
            action: () => {
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  let toggle_copy_worker_dialog = () => {
    let dialog = create_copy_worker_dialog();
    dialog.open();
  };

  const add_unit = () => {
    let target = document.querySelector('.unit-dialog');
    target.innerHTML = '';
    unit_dialog = new AddUnit({
      target: target,
      props: { order: order, order_uuid: order_uuid, has_inited: has_inited, tooltip: add_unit_tooltip },
    });
    unit_dialog.open();
  };

  const pay_for_order = async () => {
    let button = document.getElementById('payment_yes_button');
    if (button) button.disabled = true;
    let data = {
      order_uuid: order_uuid,
      app: true,
    };
    console.time('pay_init')
    window.waiting = true
    let transaction_data = await APIClient.init_pay_by_card(data);
    console.timeEnd('pay_init')
    window.waiting = false
    if (!!transaction_data) {
      nets_status = 'pay';
      show_nets = true;
      transaction_id = transaction_data.reference;
      if (button) button.disabled = false;
    }
  };

  const pay_manually = () => {
    let target = document.querySelector('.pay-manually-dialog');
    target.innerHTML = '';

    pay_dialog = new Dialog({
      target: target,
      props: {
        id: 'pay-manually-dialog',
        title: t9n(TS.ORDER_DETAILS_PAY_NOW),
        content: t9n(TS.ORDER_DETAILS_PAY_NOW_DIALOG),
        buttons: [
          {
            label: trn_cancel,
            action: () => {
              pay_dialog.close();
            },
            classes: [],
          },
          {
            label: t9n(TS.TXT_YES),
            id: 'payment_yes_button',
            action: async () => {
              await pay_for_order();
            },
            classes: [],
          },
        ],
      },
    });

    pay_dialog.open();
  };

  const btn_on_click = async (id) => {
    switch (id) {
      case 0: //share
        open_share_dialog();
        break;
      case 1: //copy
        copy_order();
        break;
      case 2: //Get payment details
        add_unit();
        break;
      case 3: //delete
        toggle_delete_dialog();
        break;
      case 4: //edit
        edit_order();
        break;
      case 5: //Browse applicants
        document
          .getElementById('select_worker_section')
          .scrollIntoView({ behavior: 'smooth' });
        break;
      case 6: //Complete
        open_complete_dialog();
        break;
      case 7: //approve
        open_approve_dialog(true);
        break;
      case 8: //not approve
        open_approve_dialog(false);
        break;
      case 9: //Show receipt
        open_receipt_dialog();
        break;
      case 10: //cancel application
        toggle_cancel_app_dialog();
        break;
      case 11: //Apply for this
        toggle_apply_dialog();
        break;
      case 12: //Get certificate
        open_certificate_dialog();
        break;
      case 13: //Get payment details
        await get_payment_details();
        break;
      case 14: //Pay manually
        pay_manually();
        break;
      case 15: //Update worker feedback
        update_worker_feedback();
        break;
    }
  };

  const toggle_hidden_users = () => {
    hidden_users = !hidden_users;
    document
      .getElementById('select_worker_section')
      .scrollIntoView({ behavior: 'smooth' });
  };

  const is_one_applicant_hidden = () => {
    let hidden_users = 0;
    for (let i = 0; i < order.applications.length; i++) {
      if (order.applications[i].hidden) hidden_users++;
    }
    return hidden_users === order.applications.length;
  };

  const init_buttons = () => {
    buttons = [
      {
        id: 'btn_order_share',
        name: 'Share order',
        icon: 'share',
        is_just_icon: true,
        condition: order.status === 'order_status_initialized',
      },
      {
        id: 'btn_order_copy',
        name: 'Copy order',
        icon: 'file_copy',
        is_just_icon: true,
        condition: role === 'orderer',
      },
      {
        id: 'btn_order_units',
        name: 'Add units',
        icon: null,
        is_just_icon: false,
        condition:
          role === 'orderer' && order.status !== 'order_status_initialized',
      },
      {
        id: 'btn_order_cancel',
        name: 'Cancel order',
        icon: 'delete',
        is_just_icon: true,
        condition:
          (role === 'orderer' &&
            (order.status === 'order_status_initialized' ||
              order.status === 'order_status_in_progress')) ||
          (role === 'worker' && order.status === 'order_status_in_progress'),
      },
      {
        id: 'btn_order_edit',
        name: 'Edit order',
        icon: 'edit',
        is_just_icon: true,
        condition:
          (role === 'orderer' && order.status === 'order_status_initialized'),
      },
      {
        id: 'btn_order_applicants',
        name: 'Browse applicants',
        icon: null,
        is_just_icon: false,
        condition:
          role === 'orderer' &&
          order.status === 'order_status_initialized' &&
          !!order.applications &&
          !is_one_applicant_hidden(),
      },
      {
        id: 'btn_order_complete',
        name: 'Complete',
        icon: null,
        is_just_icon: false,
        condition:
          role === 'worker' && (order.status === 'order_status_in_progress' || order.status === 'order_status_delivered'),
      },
      {
        id: 'btn_order_approve',
        name: 'Approve',
        icon: null,
        is_just_icon: false,
        condition:
          role === 'orderer' &&
          !!order.payment &&
          order.payment.payment_status !== 'payment_status_payment_needed' &&
          (order.status === 'order_status_delivered' ||
            order.status === 'order_status_not_approved'),
      },
      {
        id: 'btn_order_not_approve',
        name: 'Not approve',
        icon: null,
        is_just_icon: false,
        condition:
          role === 'orderer' && order.status === 'order_status_delivered',
      },
      {
        id: 'btn_order_receipt',
        name: 'Show receipt',
        icon: null,
        is_just_icon: false,
        condition:
          role === 'orderer' && order.status === 'order_status_completed',
      },
      {
        id: 'btn_order_cancel_application',
        name: 'Cancel application',
        icon: null,
        is_just_icon: false,
        condition:
          role === 'worker' &&
          order.status === 'order_status_initialized' &&
          order.you_have_applied,
      },
      {
        id: 'btn_order_apply',
        name: 'Apply for this',
        icon: null,
        is_just_icon: false,
        condition:
          role === 'worker' &&
          order.status === 'order_status_initialized' &&
          !order.you_have_applied,
      },
      {
        id: 'btn_order_certificate',
        name: 'Get certificate',
        icon: 'verified',
        is_just_icon: false,
        condition:
          role === 'worker' && order.status === 'order_status_completed',
      },
      {
        id: 'btn_order_payment',
        name: 'Get payment details',
        icon: null,
        is_just_icon: false,
        condition:
          !!order.payment_worker &&
          role === 'worker' &&
          order.status === 'order_status_completed' &&
          order.payment_worker.worker_payment_date !== null,
      },
      {
        id: 'btn_order-manual-pay',
        name: 'Pay manually',
        icon: null,
        is_just_icon: false,
        condition:
          role === 'orderer' &&
          order.status === 'order_status_delivered' &&
          !!order.payment &&
          order.payment.payment_status === 'payment_status_payment_needed',
      },
      {
        id: 'btn_update_worker_feedback',
        name: 'Update worker feedback',
        icon: null,
        is_just_icon: false,
        condition:
          order.status === "order_status_cancelled_by_orderer" && !!order.worker || order.status === "order_status_cancelled_by_worker"
      },
    ];
  };


  const is_any_hidden = () => {
    for (let i = 0; i < order.applications.length; i++) {
      if (order.applications[i].hidden) return true;
    }
    return false;
  };

  const finalize_payment = async reference => {
    if (nets_status === 'reserve') {
      let data = {
        amount: order.product.orderer_price,
        order_uuid: order_uuid,
        reference: reference,
      };
      await APIClient.finalize_reserve_card(data);
      call_select_worker = true;
      // return location.reload();
    }
    if (nets_status === 'pay') {
      let data = {
        amount: order.product.orderer_price,
        order_uuid: order_uuid,
        reference: reference,
      };
      pay_dialog.close();
      console.time('pay_finalize')
      window.waiting = true
      let result = await APIClient.finalize_pay_by_card(data);
      console.time('pay_finalize')
      window.waiting = true
      if (!!result) {
        open_approve_dialog(true);
      }
    }
  };

  const translate_texts = () => {
    apply_to_task = t9n(TS.ORDER_APPLY_TASK);
    share = t9n(TS.ORDER_SHARE);
    order_status_label = t9n(TS.ORDER_STATUS);
    button_back = t9n(TS.TXT_BACK);
    button_back_to_chat = t9n(TS.BUTTON_BACK_TO_CHAT);
    trn_cancel_order = t9n(TS.ORDER_CANCEL);
    trn_close = t9n(TS.ORDERER_TEAMS_CLOSE_LABEL);
    trn_cancel_content = t9n(TS.ORDER_CANCEL_CONFIRM);
    trn_yes = t9n(TS.TXT_YES);
    trn_cancel = t9n(TS.TXT_CANCEL);
    trn_apply_content = t9n(TS.ORDER_APPLY_CONFIRM);
    trn_apply_content_without_comment = t9n(TS.ORDER_APPLY_WITHOUT_APPLICATION);
    trn_order_cancel_appl = t9n(TS.ORDER_CANCEL_APPL);

    buttons[0].name = share;
    buttons[1].name = t9n(TS.ORDER_COPY_SIMPLE);
    if(order.product.based_on === 'product_based_hours') buttons[2].name = t9n(TS.ADD_HOURS);
    if(order.product.based_on === 'product_based_days') buttons[2].name = t9n(TS.ADD_DAYS);
    if(order.product.based_on === 'product_based_months') buttons[2].name = t9n(TS.ADD_MONTHS);
    if(order.product.based_on === 'product_based_units') buttons[2].name = t9n(TS.ADD_UNITS);
    if(order.product.based_on === 'product_based_price') buttons[2].name = t9n(TS.ADD_PRICE);
    buttons[3].name = trn_cancel_order;
    buttons[4].name = t9n(TS.ORDER_EDIT);
    buttons[5].name = t9n(TS.ORDER_BROWSE_APPL);

    if(order.status !== "order_status_delivered"){
      buttons[6].name = t9n(TS.ORDER_TASK_COMPLETE);
    } else{
      buttons[6].name = t9n(TS.ORDER_DETAILS_DURATION_EDIT_INFORMATION)
    }

    buttons[7].name = t9n(TS.ORDER_APPROVE);
    buttons[8].name = t9n(TS.ORDER_NOT_APPROVE);
    buttons[9].name = t9n(TS.ORDER_SHOW_RCPT);
    buttons[10].name = trn_order_cancel_appl;
    buttons[11].name = apply_to_task;
    buttons[12].name = t9n(TS.ORDER_GET_CERT);
    buttons[13].name = t9n(TS.ORDER_GET_PAYM_DET);
    buttons[14].name = t9n(TS.ORDER_DETAILS_PAY_NOW);
    buttons[15].name = t9n(TS.ORDER_ADD_FBACK);

    trn_your_comment = t9n(TS.ORDER_YOUR_COMMENT_LABEL);
    label_show_workers = t9n(TS.ORDER_SHOW_HWORKERS);
    label_hide_workers = t9n(TS.ORDER_HIDE_HWORKERS);
  };
  // reactive functions-------------------------------------------------------- //

  $: if (!!$session.user.last_role) role = $session.user.last_role;

  // $: if (!!$session && on_mount && !has_inited){
  //   async () => { await init_order_details() }
  // }
  $: if (!!comment_info === false) no_comment_warning = true;

  onMount(async () => { await init_order_details() });
</script>

  <main class="wrapper fade-in">

  <!-- header section  -->
  <section class="perspective" id="header_section" />

  <!-- order status, comment, icon/buttons section  -->
    <DurationWarning
      bind:order={order}
      role={role}
    />

  <div id="order_status_icons_section" class="mdc-card detail-section">
    <div class="space-between">

      <!-- order status -->
      <div id="order_status">
        <p class="font-order-status-label">{order_status_label}</p>
        <p class="font-order-status">{order_status}</p>
      </div>

      <div class='order_text'>
        {#if $session.user.last_role === 'orderer' && order?.status === 'order_status_in_progress'}
          <p>{t9n(TS.ORDER_STATUS_WORKER_SELECTED)}</p>
        {/if}
        {#if $session.user.last_role === 'worker' && order?.status === 'order_status_in_progress'}
          <p>{t9n(TS.ORDER_STATUS_RECEIVED_TASK)}</p>
        {/if}

        {#if $session.user.last_role === 'worker' && order?.status === 'order_status_initialized' && order?.you_have_applied}
          <p>{t9n(TS.ORDER_STATUS_APPLIED)}</p>
        {/if}
      </div>

      <!-- icons / buttons  -->
      <div id="order_icons_buttons">

        {#each buttons as button, i}
          {#if button.condition}
            {#if button.id === 'btn_order_certificate' && !no_certificate}
              <!-- do nothing -->
            {:else }
              <button
                id={button.id}
                style="margin-left: 5px;"
                title={button.name}
                on:click={async () => { await btn_on_click(i) }}
                class="fade-in mdc-button mdc-button--unelevated margin-5">
                <span class="mdc-button__ripple" />
                {#if button.is_just_icon}
                  <span class="material-icons">{button.icon}</span>
                {:else}{button.name}{/if}
              </button>
            {/if}
          {/if}
        {/each}
      </div>
    </div>

    <!-- comment -->
    {#if has_inited && order && role === 'worker' && order.status === 'order_status_initialized' && !order.you_have_applied}
      <div id="order_comment_field">
        <TextField
          width="100%"
          bind:value={comment_info}
          additional_class="additional_class"
          label={trn_your_comment}
          max_chars={10000}
          show_counter={false}
          single_row={true}
          cols="40" />
      </div>
    {/if}
  </div>

  <!-- feedback on order section  -->
  {#if has_inited && order && is_any_feedback()}
    <div
      id="feedback_section"
      class="mdc-card detail-section transparency flex-wrap">
      {#if has_inited && order && !is_object_empty(order.feedback.from_orderer)}
        {#if order.status === 'order_status_completed' || order.status === 'order_status_not_approved' || order.status === "order_status_cancelled_by_orderer" || order.status === "order_status_cancelled_by_worker"}
          <OrderComment
            role="orderer"
            bind:has_inited
            {order_uuid}
            bind:order
            bind:comment={order.feedback.from_orderer}
            name={get_orderer_name()}
            img={settings.api_host + order.orderer.basic_profile.image_url} />
        {/if}
      {/if}
      {#if has_inited && order && !is_object_empty(order.feedback.from_worker)}
        {#if order.status === 'order_status_delivered' || order.status === 'order_status_completed' || order.status === 'order_status_not_approved' || order.status === "order_status_cancelled_by_orderer" || order.status === "order_status_cancelled_by_worker"}
          <OrderComment
            role="worker"
            bind:has_inited
            {order_uuid}
            bind:order
            bind:comment={order.feedback.from_worker}
            name={get_worker_name()}
            img={settings.api_host + order.worker.basic_profile.image_url} />
        {/if}
      {/if}
    </div>
  {/if}

  <!--  order info section -->
  {#if has_inited && order}
    {#if role === 'orderer' && order.status === 'order_status_initialized'}
      <!--  do nothing? what if we would reorder the condition? -->
    {:else if role === 'orderer'}
      <div id="order_info_section" class="mdc-card detail-section">
        <TableUser
          bind:role
          bind:order
          is_historical_order={is_history_order(order)} />
      </div>
    {:else if order.status === 'order_status_initialized'}
      {#if !!order.orderer.basic_profile.short_description_orderer}
        <div id="order_info_section" class="mdc-card detail-section">
          <TableUser
            bind:role
            bind:order
            is_historical_order={is_history_order(order)} />
        </div>
      {/if}
    {:else}
      <div id="order_info_section" class="mdc-card detail-section">
        <TableUser
          bind:role
          bind:order
          is_historical_order={is_history_order(order)} />
      </div>
    {/if}
  {/if}

    <!--{#if !!order}-->
    <!--<div id="order_info_section" class="mdc-card detail-section">-->
    <!--  <Rating {order}/>-->
    <!--</div>-->
    <!--{/if}-->


  <div id="order_info_section" class="mdc-card detail-section">
    <TableOrder bind:role bind:order />
  </div>

  {#if !!order}
    {#if !!order.applications}
      {#if has_inited && role === 'orderer' && order.status === 'order_status_initialized' && order.applications.length > 0 && is_any_hidden()}
        <div id="order_info_section" class="mdc-card detail-section">
          <button
            style=""
            title="Show hidden users"
            on:click={() => toggle_hidden_users()}
            class="fade-in mdc-button mdc-button--unelevated margin-5">
            <span class="mdc-button__ripple" />
            {#if !hidden_users}
              {label_show_workers}
            {:else}{label_hide_workers}{/if}

          </button>

        </div>
      {/if}
    {/if}
  {/if}

  <!-- select worker section  -->
  {#if !!order}
    {#if !!order.applications}
      {#if has_inited && role === 'orderer'}
        {#if order.status === 'order_status_initialized' && order.applications.length > 0}
          <div id={'select_worker_section'} class="mdc-card detail-section">
            <SelectUser
              bind:nets_status
              select_applicant_flag={select_applicant}
              {worker_id}
              {make_a_copy}
              bind:call_select_worker
              bind:hidden_users
              bind:order
              bind:transaction_id
              bind:show_nets
              bind:applications={order.applications}
              bind:order_uuid />
          </div>
        {/if}
      {/if}
    {/if}
  {/if}
  <!-- bottom section -->

  {#if partner_id}
    <div id="button_back_to_chat">
      <button
        on:click={back}
        class="mdc-button mdc-button--unelevated order-back-button">
        <span class="mdc-button__ripple" />
        {button_back_to_chat}
      </button>
    </div>
  {:else}
    <div id="bottom_buttons_section">
      <button
        on:click={back}
        class="mdc-button mdc-button--unelevated order-back-button">
        <span class="mdc-button__ripple" />
        {button_back}
      </button>
    </div>
  {/if}

  <!--general dialog container-->
  <div class="delete-dialog" />
  <div class="apply-dialog" />
  <div class="cancelapp-dialog" />
  <div class="receipt-dialog" />
  <div class="certificate-dialog" />
  <div class="share-dialog" />
  <div class="approve-dialog" />
  <div class="complete-dialog" />
  <div class="copy-worker-dialog" />
  <div class="unit-dialog" />
  <div class="pay-manually-dialog" />
  <div class="update-dialog" />

  <NetsPaymentWindow
    {nets_host}
    {transaction_id}
    bind:show={show_nets}
    callback={finalize_payment} />
</main>

<style type="text/scss">

  .order_text p{
    color: #616161;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    font-size: .875rem;
  }
  /* Reset Styles
    *********************/

  * {
    box-sizing: border-box;
    margin: 0;
    text-decoration: none;
    /*padding: 0;*/
  }

  html,
  body,
    /* main { display: flex; flex-direction: column; min-height: 100vh; } */

  main {
    display: flex;
    flex-direction: column;
    margin-top: 3rem !important;
    padding: 0.5rem 0.5rem;
    background: #ffffff8c;
    border-radius: 10px;
  }

  section {
  }

  img {
    max-width: 100%;
  }

  input[type='number'] {
    text-align: center;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    opacity: 1;
  }

  /* Page local
    *********************/

  .space-between {
    display: flex;
    //justify-content: space-between;
    margin-top: 5px;
    margin-bottom: 10px;
    position: relative;
  }

  #order_status {
    margin-left: 13px;
  }

  .font-order-status-label {
    color: #616161;
    font-weight: 800;
    text-align: left;
    max-width: 300px;
    min-width: 150px;
    word-wrap: break-word;
    white-space: normal;
    font-size: 0.875rem;
  }

  .font-order-status {
    font-style: italic;
    font-family: Roboto, sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    text-transform: inherit;
    color: rgba(0, 0, 0, 0.5);
    text-align: left;
  }

  .detail-section {
    margin-top: 8px;
    padding: 24px;
  }

  .transparency {
    background: #ffffffde;
  }

  .order-back-button {
    margin-top: 8px;
    width: 100%;
  }

  .flex-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  /* Needed for 3D sign effect */
  .perspective {
    -webkit-perspective: 1300px;
    -moz-perspective: 1300px;
    perspective: 1300px;
  }

  .chat-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    /* max-width: 800px; */
    height: 60vh;
    background: #eef0f0e3;
    box-shadow: 2px 1px 10px rgba(169, 166, 166, 0.4);
    margin: 0 auto;
    margin-top: 8px;
    border-radius: 8px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .wrapper {
      width: 1000px;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
    }

    #order_icons_buttons{
      position: absolute;
      right: 0;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .wrapper {
      width: 90%;
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .wrapper {
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }

    #order_icons_buttons > button {
      margin-top: 2px;
      width: 23%;
    }
  }
</style>
